<div class="border-bottom container-fluid mw-100">
  @if (visitSummary(); as summary) {
    <div class="row p-3 gx-3 main-row">
      <div class="col-auto d-none d-md-none d-lg-block d-vlg-none d-xl-block">
        @if (summary.vesselImageUrl) {
          <button class="hover-show position-relative" type="button" (click)="zoomVesselImage.emit(summary)"
            style="background-color: transparent; border-width: 0; padding: 0;">
            <img src="{{summary.vesselImageUrl}}" width="102" height="68" alt="Vessel image" class="rounded-1"/>
            <img src="/assets/new-portvisit/zoom.svg" width="30px" alt="zoom" class="to-show rounded-1 position-absolute end-0 bottom-0"/>
          </button>
        }
        @if (!summary.vesselImageUrl) {
          <img src="/assets/new-portvisit/no-vessel-image.svg" width="102" height="68" alt="Vessel image" class="rounded-1"/>
        }
      </div>
      <div class="col col-vlg-3 col-xxl-2">
        <a [href]="navigationUrl()">
          <span class="h2 text-info">
            <app-highlight [term]="term()" [result]="summary.vesselName | sentenceCase"></app-highlight>
          </span>
          <span class="h2 text-info d-none d-lg-inline"> - </span>
          <span class="h2 text-info d-none d-lg-inline"><app-highlight [term]="term()" [result]="summary.imoCode"></app-highlight></span>
        </a>
        @if (summary.tidalShip) {
          <app-tooltip placement="top" class="ms-2">
            <span class="fa fa-fw fa-water-arrow-down text-info"></span>
            <span class="tooltipContent">This ship is tide restricted</span>
          </app-tooltip>
        }
        @if (summary.dependencyType === 'EXCHANGE') {
          <app-tooltip placement="top" class="ms-2">
            <span class="fa fa-light fa-fw fa-arrow-right-arrow-left text-info mx-1"></span>
            <span class="tooltipContent">Exchanges with <span class="fw-medium">{{summary.dependentVesselName | titlecase}}</span></span>
          </app-tooltip>
        }
        @if (!summary.hasBeenTransferred && summary.nextDeclarantShortName && (summary.declarantShortName === appContext.userProfile.organisation.shortName || appContext.isAdmin())) {
          <app-tooltip placement="top" class="ms-2">
            <span class="fa fa-light fa-fw fa-people-arrows text-info mx-1"></span>
            <span class="tooltipContent">Handover to <span class="fw-medium">{{summary.nextDeclarant}}</span></span>
          </app-tooltip>
        }
        @if (!summary.hasBeenTransferred && summary.nextDeclarantShortName && summary.nextDeclarantShortName === appContext.userProfile.organisation.shortName) {
          <app-tooltip placement="top" class="ms-2">
            <span class="fa fa-light fa-fw fa-people-arrows text-info mx-1"></span>
            <span class="tooltipContent">Handover from <span class="fw-medium">{{summary.declarant}}</span></span>
          </app-tooltip>
        }
        @if (summary.hasBeenTransferred && summary.originalDeclarantShortName !== summary.declarantShortName && summary.declarantShortName === appContext.userProfile.organisation.shortName) {
          <app-tooltip placement="top" class="ms-2">
            <span class="fa fa-light fa-fw fa-arrow-right text-info mx-0" style="margin-right: -5px !important;"></span>
            <span class="fa fa-light fa-fw fa-person text-info mx-0"></span>
            <span class="tooltipContent">Handed over from <span class="fw-medium">{{summary.originalDeclarant}}</span></span>
          </app-tooltip>
        }
        @if (summary.cancelled) {
          <app-tooltip placement="top" class="ms-2">
            <span class="fa text-danger fa-fw fa-ban"></span>
            <span class="tooltipContent">Cancelled</span>
          </app-tooltip>
        }
        <div class="d-flex flex-row align-items-stretch">
          <div class="d-flex flex-column" style="min-width: 130px; max-width: 130px;">
            <span class="d-inline-block text-truncate mw-100">
              <app-highlight [term]="term()" [result]="summary.crn"></app-highlight>
            </span>
            <span class="d-inline-block text-truncate mw-100">
              <app-highlight [term]="term()" [result]="summary.arrivalVoyageNumber"></app-highlight>
            </span>
          </div>
          @if (summary.vessel) {
            <div class="d-none flex-column d-lg-flex" style="min-width: 0">
              <span class="d-inline-block text-truncate mw-100 me-2">{{summary.vessel.length | round}}
              x {{summary.vessel.width | round}} m</span>
              <span class="d-inline-block text-truncate mw-100">{{summary.vessel.grossTonnage | round}} t</span>
            </div>
          }
        </div>
      </div>
      <div class="col-3 d-none d-vlg-block col-vlg col-xxl-3">
        <app-movement-icons [movements]="movements()" [term]="term()" [middleStatus]="summary.visitStatus === 'DEPARTED' ? 'departed' : summary.visitStatus === 'ARRIVED' ? 'arrived' : 'expected'"></app-movement-icons>
      </div>
      <div class="d-none d-xxl-flex align-items-center justify-content-end flex-column" [style.min-width.px]="150" [ngClass]="isStevedorePlannerAtAnyBerthVisit() ? 'col-2' : 'col-xxl'">
        <div class="row gy-2 gx-1 mw-100">
          <div class="col-auto">
            <app-tooltip style="line-height: 1.5rem;">
              <i class="fa-light fa-user"></i>
              <span class="tooltipContent">Last edited by this user from your company</span>
            </app-tooltip>
            <div></div>
          </div>
          <div class="col d-flex flex-column" style="min-width: 0">
            <span class="d-inline-block text-truncate mw-100">
              <app-highlight [term]="term()"
              [result]="summary.lastEditedByUser?.name || summary.lastEditedByUser?.orgName || 'Not available'"></app-highlight>
            </span>
            <span
            class="d-inline-block text-truncate mw-100">{{summary.lastEditedByUser ? (entryDate() | date:'dd MMM HH:mm') || 'No date' : 'Not available'}}</span>
          </div>
        </div>
      </div>
      @if (isStevedorePlannerAtAnyBerthVisit()) {
        <div class="col ms-auto">
          <div class="row gy-2 gx-3">
            <div class="col-12 d-flex flex-column status-column status-column-left">
              <app-stevedore-visit-overview-service-status
                [summary]="summary"
                [serviceStatusButtonId]="'buttonTerminal' + summary.crn"
              [serviceStatusSpanId]="'spanTerminal' + summary.crn"></app-stevedore-visit-overview-service-status>
            </div>
          </div>
        </div>
      } @else {
        <div class="col-auto ms-auto">
          <div class="row gy-2 gx-3">
            <div class="col-auto d-flex flex-column status-column status-column-left">
              <div class="row g-0 gx-2">
                <div class="col-auto d-flex flex-column">
                  <span (mouseover)="hoverStatusIndicatorSpan('spanPortAuthority' + summary.crn, true)"
                    (mouseout)="hoverStatusIndicatorSpan('spanPortAuthority' + summary.crn, false)"
                    id="spanPortAuthority{{summary.crn}}"
                  class="d-none d-sm-inline-block text-start cursor-pointer" [style.line-height.rem]="1.5" (click)="popupStatusIndicator('buttonPortAuthority' + summary.crn)">Port Authority</span>
                  <span (mouseover)="hoverStatusIndicatorSpan('spanCustoms' + summary.crn, true)"
                    (mouseout)="hoverStatusIndicatorSpan('spanCustoms' + summary.crn, false)"
                    id="spanCustoms{{summary.crn}}"
                  class="d-none d-sm-inline-block text-start cursor-pointer" [style.line-height.rem]="1.5" (click)="popupStatusIndicator('buttonCustoms' + summary.crn)">Customs</span>
                  @if (!summary.portUnCode || areNauticalServicesApplicable()) {
                    <span (mouseover)="hoverStatusIndicatorSpan('spanServices' + summary.crn, true)"
                      (mouseout)="hoverStatusIndicatorSpan('spanServices' + summary.crn, false)"
                      id="spanServices{{summary.crn}}"
                    class="d-none d-sm-inline-block text-start cursor-pointer" [style.line-height.rem]="1.5" (click)="popupStatusIndicator('buttonServices' + summary.crn)">Services</span>
                  }
                </div>
                <div class="col d-flex flex-column">
                  <app-visit-overview-service-status
                    [summary]="summary"
                    [declarationTypes]="$any(['VISIT', 'HEALTH', 'SECURITY', 'WASTE', 'DANGEROUS_GOODS'])"
                    [statusIndicatorButtonId]="'buttonPortAuthority' + summary.crn"
                    [statusIndicatorSpanId]="'spanPortAuthority' + summary.crn">
                  </app-visit-overview-service-status>
                  <app-visit-overview-service-status
                    [summary]="summary"
                    [declarationTypes]="$any(declarationTypesConsideringICS2())"
                    [inspectionStatus]="true"
                    [statusIndicatorButtonId]="'buttonCustoms' + summary.crn"
                    [statusIndicatorSpanId]="'spanCustoms' + summary.crn">
                  </app-visit-overview-service-status>
                  @if (!summary.portUnCode || areNauticalServicesApplicable()) {
                    <app-visit-overview-service-status
                      [summary]="summary"
                      [statusIndicatorButtonId]="'buttonServices' + summary.crn"
                      [statusIndicatorSpanId]="'spanServices' + summary.crn"
                    [orderStatus]="true"></app-visit-overview-service-status>
                  }
                </div>
              </div>
            </div>
            <div class="col-auto d-flex flex-column status-column status-column-right">
              <div class="row g-0 gx-2">
                <div class="col-auto d-flex flex-column">
                  <span (mouseover)="hoverStatusIndicatorSpan('spanBorderPatrol' + summary.crn, true)"
                    (mouseout)="hoverStatusIndicatorSpan('spanBorderPatrol' + summary.crn, false)"
                    id="spanBorderPatrol{{summary.crn}}"
                  class="d-none d-sm-inline-block text-start cursor-pointer" [style.line-height.rem]="1.5" (click)="popupStatusIndicator('buttonBorderPatrol' + summary.crn)">Border patrol</span>
                  @if (leastTerminalStatus() !== 'DISABLED') {
                    <span (mouseover)="hoverStatusIndicatorSpan('spanTerminal' + summary.crn, true)"
                      (mouseout)="hoverStatusIndicatorSpan('spanTerminal' + summary.crn, false)"
                      id="spanTerminal{{summary.crn}}"
                    class="d-none d-sm-inline-block text-start cursor-pointer" [style.line-height.rem]="1.5" (click)="popupServiceStatus('buttonTerminal' + summary.crn)">Terminal</span>
                  }
                  @if (summary.harbourDuesEnabled) {
                    <span (mouseover)="hoverStatusIndicatorSpan('spanHarbourDues' + summary.crn, true)"
                      (mouseout)="hoverStatusIndicatorSpan('spanHarbourDues' + summary.crn, false)"
                      id="spanHarbourDues{{summary.crn}}"
                    class="d-none d-sm-inline-block text-start cursor-pointer" [style.line-height.rem]="1.5" (click)="popupStatusIndicator('buttonHarbourDues' + summary.crn)">Harbour dues</span>
                  }
                </div>
                <div class="col d-flex flex-column">
                  <app-visit-overview-service-status [summary]="summary"
                    [statusIndicatorButtonId]="'buttonBorderPatrol' + summary.crn"
                    [statusIndicatorSpanId]="'spanBorderPatrol' + summary.crn"
                  [declarationTypes]="$any(['PAX'])"></app-visit-overview-service-status>
                  @if (leastTerminalStatus() !== 'DISABLED') {
                    <app-terminal-visit-overview-service-status
                      [summary]="summary"
                      [serviceStatusButtonId]="'buttonTerminal' + summary.crn"
                      [serviceStatusSpanId]="'spanTerminal' + summary.crn">
                    </app-terminal-visit-overview-service-status>
                  }
                  <app-visit-overview-service-status
                    [summary]="summary"
                    [declarationTypes]="[]"
                    [statusIndicatorButtonId]="'buttonHarbourDues' + summary.crn"
                    [statusIndicatorSpanId]="'spanHarbourDues' + summary.crn"
                    [harbourDues]="summary.harbourDuesEnabled">
                  </app-visit-overview-service-status>
                </div>
              </div>
            </div>
          </div>
        </div>
      }
      <div class="col-auto d-flex flex-column align-items-center dropdown px-2">
        <a [href]="navigationUrl()" class="btn rounded-circle p-2 text-primary h1 mb-0 action-btn-lg" type="button" [style.margin-top.px]="-10">
          <i class="fa-light fa-fw fa-angle-right"></i>
        </a>
        <button class="btn rounded-circle p-2 text-primary h1 mt-0 action-btn-lg" type="button" [style.margin-bottom.px]="-10"
          data-bs-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
          <i class="fa-light fa-fw fa-ellipsis-vertical"></i>
        </button>
        <div class="dropdown-menu position-fixed">
          @if (showViewInboundCargo()) {
            <a [routerLink]="'/cargo/' + summary.crn" class="btn dropdown-item">
              <i class="fa-light fa-arrow-up-right-from-square"></i>
              View inbound cargo
            </a>
          }
          @if (appContext.isAdmin()) {
            <button class="btn dropdown-item" (click)="tryRefreshVisitSummary()">
              <i class="fa-light fa-arrows-rotate"></i>
              Refresh visit summary
            </button>
          }
          <a [href]="'https://www.marinetraffic.com/en/ais/details/ships/imo:'+summary.imoCode"
            class="btn dropdown-item">
            <i class="fa-light fa-arrow-up-right-from-square"></i>
            View in MarineTraffic
          </a>
          @if (!appContext.isProduction()) {
            <a [href]="appContext.getMaritimeFormalitiesLink(summary.crn)"
               target="_blank" class="btn dropdown-item">
              <i class="fa-light fa-arrow-up-right-from-square"></i>
              View in Maritime Formalities
            </a>
          }
          @if (isOrganisationCurrentVisitDeclarant() && !summary.cancelled && expected()) {
            <hr class="dropdown-divider">
            <button class="btn dropdown-item" (click)="cancelVisit()">
              <i class="fa-light fa-ban"></i>
              Cancel visit
            </button>
          }
        </div>
      </div>
    </div>
  }
</div>
